import { Button, Heading, Link } from '@chakra-ui/react'

import { Container } from '../../../components/Container'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { Recap } from '../../../containers/cestovko/Recap'
import { MeetingRecordOverview } from '../../../containers/MeetingRecordOverview'
import { ContractRecap } from '../../../containers/cestovko/ContractRecap'
import { InsuranceSummary } from '../../../containers/InsuranceSummary'
import { FormButtons } from '../../../containers/FormButtons'
import { Duplicate } from '../../../icons'
import { useContext } from 'react'
import { insuranceParamsContext, useInsuranceParamsContext } from '../../../layouts/Wizard'
import { Loading } from '../../../components/Loading'
import { InsuranceDownloads } from '../../../containers/carkulka/InsuranceDownloads'
import { baseUrl } from '../../../hooks'
import {
  FormSection,
  FormSectionBody,
  FormSectionDescription,
  FormSectionHeader,
  FormSectionTitle,
} from '../../../components/FormSection'
import { ContractEmailHistory } from '../../../containers/carkulka/ContractEmailHistory'
import { ContractAcceptationType } from 'BrokerTsLib/src/enums'

const insuranceParamsApiUrl = process.env.REACT_APP_INSURANCEPARAMSTRAVEL_API
const insuranceParamsUrl = `${baseUrl}/${insuranceParamsApiUrl}`
const carkulkaUrl = process.env.REACT_APP_CARKULKA_URL

export const CompletedPage = () => {
  const { insuranceParams, insuranceParamsId, isLoadingData } = useInsuranceParamsContext()

  const sendMailUrl = `${carkulkaUrl}/Mailing/GetContractEmail/${insuranceParamsId}`

  return (
    <Section>
      <Container>
        <StepsContent step={5}>
          {isLoadingData && <Loading sx={{ marginRight: 8, display: 'flex' }} />}
          {!isLoadingData && (
            <Heading
              sx={{
                fontSize: '5xl',
                fontWeight: 'bold',
                letterSpacing: 'tighter',
                textAlign: 'center',
              }}
              as="h1"
            >
              Sjednané pojištění č. {insuranceParams?.generalParams.contractNumber}
            </Heading>
          )}

          <Steps icon="beach" />

          <InsuranceSummary />

          <MainContent>
            <Recap />

            <FormSection>
              <FormSectionHeader>
                <FormSectionTitle>Dokumenty k pojištění</FormSectionTitle>

                <FormSectionDescription>
                  <Button
                    as={Link}
                    href={sendMailUrl}
                    target="_blank"
                    variant="outline"
                    type="button"
                  >
                    Odeslat e-mail klientovi
                  </Button>
                </FormSectionDescription>
              </FormSectionHeader>

              <FormSectionBody>
                {insuranceParams?.generalParams.selectedOfferId && (
                  <InsuranceDownloads offerId={insuranceParams.generalParams.selectedOfferId} />
                )}

                {insuranceParams?.generalParams.paramsId &&
                  insuranceParams.generalParams.contractAcceptationType ===
                    ContractAcceptationType.Payment && (
                    <ContractEmailHistory
                      paramsId={insuranceParams?.generalParams.paramsId}
                      onResend={() => window.open(sendMailUrl)}
                    />
                  )}
              </FormSectionBody>
            </FormSection>

            <ContractRecap />

            <MeetingRecordOverview />
          </MainContent>
        </StepsContent>

        <FormButtons
          leftButtons={
            <Button
              variant="outline"
              as="a"
              href={`${insuranceParamsUrl}/CloneUrl?paramsId=${insuranceParamsId}&replacement=${false}&returnUrl=${encodeURIComponent(`${baseUrl}/cestovko/wizard/1`)}`}
            >
              <Duplicate color="secondary.500" />
              Klonovat
            </Button>
          }
        />
      </Container>
    </Section>
  )
}
